"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IMAGE_WITH_SKELETON = void 0;
const IMAGE_WITH_SKELETON = exports.IMAGE_WITH_SKELETON = 'image-with-skeleton';
